import React, { useState } from "react";
import { Box, IconButton, TextField, useTheme } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const ChatInput = ({ onSend }) => {
  const theme = useTheme();
  const [text, setText] = useState("");

  const handleSend = () => {
    if (!text.trim()) return;
    onSend(text);
    setText("");
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box sx={{
      p: 1.5,
      display: "flex",
      alignItems: "center",
      gap: 1,
      bgcolor: '#f5f5f5',
      borderTop: '1px solid rgba(0,0,0,0.1)'
    }}>
      <TextField
        fullWidth
        size="small"
        placeholder="Type a message..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyPress={handleKeyPress}
        sx={{
          bgcolor: 'white',
          borderRadius: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            '& fieldset': {
              borderColor: 'rgba(0,0,0,0.15)',
            },
            '&:hover fieldset': {
              borderColor: theme.palette.primary.main,
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
              borderWidth: '2px',
            },
          },
          '& .MuiOutlinedInput-input': {
            padding: '10px 14px',
          },
        }}
      />
      <IconButton
        onClick={handleSend}
        disabled={!text.trim()}
        sx={{
          bgcolor: theme.palette.primary.main,
          color: '#fff',
          '&:hover': {
            bgcolor: theme.palette.primary.dark
          },
          '&:disabled': {
            bgcolor: 'rgba(0,0,0,0.12)',
            color: 'rgba(0,0,0,0.26)'
          }
        }}
      >
        <SendIcon />
      </IconButton>
    </Box>
  );
};

export default ChatInput;
